function confirmRestoreAssetVersionDialog () {
  return {
    restrict: 'E',
    templateUrl: '/repository/dialogs/confirm-restore-asset-version/confirm-restore-asset-version-dialog.html?$$REVISION$$'
  }
}

export { confirmRestoreAssetVersionDialog }
